import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import cardDeliveryHome from '../views/cardDelivery/Home.vue'

import app from '../App.vue'
import { getImgUrl } from '@/api/index'
import { getPicUrl, setPicUrl } from '@/utils/utils'
Vue.use(VueRouter)

const routes = [
	{
		path: '/home',
		name: 'Home',
		meta: {
			title: '中青畅游',
			deepth: 0.5,
			keepAlive: true //需要被缓存的
		},
		component: Home
	},
	{
		path: '/cardDelivery/home',
		name: 'cardDeliveryHome',
		meta: {
			title: '',
			deepth: 0.5,
			keepAlive: true //需要被缓存的
		},
		component: cardDeliveryHome
	},
	{
		path: '/cardactive',
		name: 'CardActive',
		meta: {
			title: '购卡',
			deepth: 1
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import ( /* webpackChunkName: "about" */ '../views/CardActive.vue')
	},
	{
		path: '/cardDelivery/cardDelivery',
		name: 'cardDelivery',
		meta: {
			title: '领卡',
			deepth: 1
		},
		component: () => import ('@/views/cardDelivery/cardDelivery.vue')
	},
	{
		path: '/routergo',
		name: 'RouterGo',
		meta: {
			title: '',
			deepth: 1
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import ( /* webpackChunkName: "about" */ '../views/RouterGo.vue')
	},
	{
		path: '/qrcode',
		name: 'Qrcode',
		meta: {
			title: '支付成功',
			deepth: 1
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import ('../views/Qrcode.vue')
	},
	{
		path: '/cardDelivery/qrcode',
		name: 'cardDeliveryQrcode',
		meta: {
			title: '前往小程序',
			deepth: 1
		},
		component: () => import ('@/views/cardDelivery/Qrcode.vue')
	},
	{
		path: '/couponManage',
		meta: { title: '优惠券管理'},
		redirect: '/couponManage/index',
		component: app,
		children: [
			{
				path: 'index',
				meta: { title: '优惠券', deepth: 1, keepAlive: true},
				name: 'Coupon',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/couponManage/index.vue')
			}
		]
	},
	{
		path: '/onlineService',
		meta: { title: '在线客服'},
		redirect: '/onlineService/index',
		component: app,
		children: [
			{
				path: 'index',
				meta: { title: '在线客服', deepth: 1, keepAlive: true},
				name: 'OnlineService',
				component: () => import ('@/views/onlineService/index.vue')
			}
		]
	},
	{
		path: '/agreement',
		meta: { title: '隐私条款'},
		redirect: '/agreement/meiyoumei',
		component: app,
		children: [
			{
				path: 'meiyoumei',
				meta: { title: '隐私条款', deepth: 1, keepAlive: true},
				name: 'PrivacyPolicy',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/agreement/meiyoumei/privacyPolicy.vue')
			},
			{
				path: 'meiyoumei/serviceagreement',
				meta: { title: '服务协议', deepth: 1, keepAlive: true},
				name: 'ServiceAgreement',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/agreement/meiyoumei/serviceAgreement.vue')
			}
		]
	},
	{
		path: '/programJump',
		meta: { title: '小程序跳转'},
		redirect: '/programJump/cxbz',
		component: app,
		children: [
			{
				path: 'cxbz',
				meta: { title: '中青自由行', deepth: 1, keepAlive: true},
				name: 'Cxbz',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/programJump/cxbz.vue')
			},
			{
				path: 'meiyoumei/serviceagreement',
				meta: { title: '服务协议', deepth: 1, keepAlive: true},
				name: 'ServiceAgreement',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/agreement/meiyoumei/serviceAgreement.vue')
			}
		]
	},
	{
		path: '/holidays',
		meta: { title: ''},
		component: app,
		children: [
			{
				path: '521',
				meta: { title: '521携爱同行！', deepth: 1, keepAlive: true},
				name: 'Lover521',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () => import ( /* webpackChunkName: "about" */ '@/views/holidays/521.vue')
			}
		]
	},
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
	document.title = to.meta.title ? to.meta.title : ''
	if(!getPicUrl()) {
		try {
			const res = await getImgUrl()
			if(res.data.code == '200'){
				setPicUrl(res.data.data)
				next()
			}
		} catch (error) {
			console.log(error)
		}
	} else {
		next()
	}
})


export default router